var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgShoppingList = function SvgShoppingList(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.825 10.349a1.437 1.437 0 0 1-1.016 2.454H4.437a1.437 1.437 0 1 1 0-2.875h1.197a.178.178 0 0 0 .163-.103l2.498-5.31a.898.898 0 0 1 1.626.766L7.854 9.672a.18.18 0 0 0 .163.256h7.097a.179.179 0 0 0 .165-.252l-1.962-4.413a.9.9 0 0 1 1.643-.73l2.35 5.289a.18.18 0 0 0 .164.106h1.335c.381 0 .747.151 1.016.421zM4.796 13.88H18.45a.359.359 0 0 1 .352.431l-.92 4.6a1.692 1.692 0 0 1-1.78 1.077H7.144a1.692 1.692 0 0 1-1.778-1.078l-.92-4.598a.36.36 0 0 1 .351-.432zm3.773 2.156v1.797a.539.539 0 1 0 1.078 0v-1.797a.54.54 0 0 0-1.078 0zm5.95 2.178a.54.54 0 0 0 .158-.381v-1.797a.54.54 0 0 0-1.078 0v1.797a.539.539 0 0 0 .92.38z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShoppingList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "shopping-list.5ae9ae6bf61cab8bbfe2d87696db3862.svg";